import React, { useState } from "react";
import { FaQuoteLeft, FaChevronLeft, FaChevronRight } from "react-icons/fa";

const Testimonials = ({ 
  testimonials, 
  title = "What Our Clients Say",
  subtitle = "Real stories from our satisfied clients who achieved their Australian dreams"
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  const currentTestimonial = testimonials[currentIndex];

  return (
    <div className="container max-w-1440px mx-auto px-4 py-6 xl:py-10 lg:px-14">
      <div className="text-center">
        <h2 className="lg:text-[38px] text-2xl text-blue font-semibold hellix-font mb-4">
          {title}
        </h2>
        <p className="text-blue font-normal text-lg lg:text-[22px] hellix-font mb-8">
          Real stories from our satisfied clients who achieved their Australian dreams
        </p>
      </div>

      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-custom-white p-8 md:p-12 relative">
          {/* Quote Icon */}
          <div className="flex justify-center mb-6">
            <div className="bg-blue rounded-full p-4">
              <FaQuoteLeft className="text-white text-2xl" />
            </div>
          </div>

          {/* Testimonial Content */}
          <div className="text-center">
            <p className="text-blue text-lg lg:text-[22px] hellix-font font-normal mb-6 italic leading-relaxed">
              "{currentTestimonial.content}"
            </p>
            
            {/* Client Info */}
            <div className="border-t border-gray-200 pt-6">
              <h4 className="text-blue text-xl lg:text-2xl hellix-font font-semibold mb-1">
                {currentTestimonial.name}
              </h4>
              {currentTestimonial.location && (
                <p className="text-[#667d87] text-lg hellix-font">
                  {currentTestimonial.location}
                </p>
              )}
              {currentTestimonial.visaType && (
                <p className="text-blue text-sm hellix-font font-medium mt-2">
                  {currentTestimonial.visaType}
                </p>
              )}
            </div>
          </div>

          {/* Navigation Arrows (only show if more than 1 testimonial) */}
          {testimonials.length > 1 && (
            <>
              <button
                onClick={prevTestimonial}
                className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-blue text-white p-3 rounded-full hover:bg-blue-600 transition-colors duration-300"
                aria-label="Previous testimonial"
              >
                <FaChevronLeft />
              </button>
              <button
                onClick={nextTestimonial}
                className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-blue text-white p-3 rounded-full hover:bg-blue-600 transition-colors duration-300"
                aria-label="Next testimonial"
              >
                <FaChevronRight />
              </button>
            </>
          )}
        </div>

        {/* Dots Pagination (only show if more than 1 testimonial) */}
        {testimonials.length > 1 && (
          <div className="flex justify-center mt-6 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors duration-300 ${
                  index === currentIndex 
                    ? 'bg-blue' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        )}

        {/* Statistics (optional - can be passed as props) */}
        {currentTestimonial.stats && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            {currentTestimonial.stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl lg:text-4xl font-bold text-blue hellix-font">
                  {stat.number}
                </div>
                <div className="text-[#667d87] text-lg hellix-font">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Testimonials;